'use client';

import { FingerprintJSPro } from '@fingerprintjs/fingerprintjs-pro-react';
import { useEffect } from 'react';
import { Env } from '@/consts/Env';
import { isProduction } from '@/libs/getEnvironment';

const subdomain = 'https://fingerprint.sweepking.com';
const scriptUrlPattern = `${subdomain}/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`;

type FingerprintAgent = Awaited<ReturnType<typeof FingerprintJSPro.load>>;

let agentPromise: Promise<FingerprintAgent> | null = null;

export function getFingerprintAgent(): Promise<FingerprintAgent> | null {
  return agentPromise;
}

export default function FingerprintAnalytics() {
  const apiKey = isProduction()
    ? Env.NEXT_PUBLIC_FINGERPRINTJS_API_KEY_PROD
    : Env.NEXT_PUBLIC_FINGERPRINTJS_API_KEY_STAGING;

  useEffect(() => {
    if (!apiKey || agentPromise) {
      return;
    }

    agentPromise = FingerprintJSPro.load({
      apiKey,
      endpoint: [subdomain, FingerprintJSPro.defaultEndpoint],
      scriptUrlPattern: [scriptUrlPattern, FingerprintJSPro.defaultScriptUrlPattern],
    });
  }, [apiKey]);

  return null;
}
